module.exports = __webpack_public_path__ + "img/new_45.6f8e0d51.jpg";